export const regularExpression = /-[A-Z]{2}\//i;
